import React from 'react';

const NotFound = () => {
  return (
    <div>
      <br />
      <br />
      <div className='container'>
        <div className='d-flex j-center a-center'>
          <h4> 404 | page not found </h4>
        </div>
      </div>
      <br />
      <br />
    </div>
  );
};

export default NotFound;
